import OgImageModelCommon from 'common/models/og-image';

export default class OgImageModel extends OgImageModelCommon {}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'og-image': OgImageModel;
  }
}
